import { minutesToHHMM, type TaskItem } from '@skolveckan/shared';
import { subjectColors } from '../lib/subjects';

interface Props {
  task: TaskItem;
  onToggle: (task: TaskItem) => void;
  onOpenLesson?: (lessonId: string) => void;
}

export function TaskRow({ task, onToggle, onOpenLesson }: Props) {
  const done = task.state === 'done';
  const colors = subjectColors(task.colorKey);

  return (
    <div className={`taskrow${done ? ' taskrow--done' : ''}`}>
      <input
        type="checkbox"
        id={`task-${task.id}`}
        checked={done}
        onChange={() => onToggle(task)}
      />
      <span
        className="taskrow__spine"
        style={{ background: task.colorKey ? colors.line : 'var(--line)' }}
        aria-hidden="true"
      />
      <label className="taskrow__label" htmlFor={`task-${task.id}`}>
        <span className="taskrow__title">{task.title}</span>
        {task.subtitle && <span className="taskrow__meta">{task.subtitle}</span>}
      </label>

      {task.isExam && <span className="chip chip--danger">Prov</span>}
      {!task.isExam && task.dueMin != null && (
        <span className="taskrow__due">{minutesToHHMM(task.dueMin)}</span>
      )}

      {task.lessonId && onOpenLesson && (
        <button
          type="button"
          className="taskrow__open"
          onClick={() => onOpenLesson(task.lessonId!)}
        >
          Öppna
        </button>
      )}
    </div>
  );
}
